import { html } from "lit";
var icon_qCulturalInsights_default = () => html`
  <svg stroke-fill viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.94 21.63A9.71 9.71 0 0 0 19.96 8.7a9.8 9.8 0 0 0-15.95 7.06 9.72 9.72 0 0 0 8.3 10.12c2.4.36 4.84-.17 6.86-1.5l1.05 1.04a1.96 1.96 0 0 0 3.34-1.38c0-.51-.2-1.01-.57-1.38l-1.05-1.04Zm-8.16.47a5.88 5.88 0 0 1-5.64-4.22 5.83 5.83 0 0 1 2.5-6.57 5.89 5.89 0 0 1 8.9 3.8c.24 1.23.08 2.52-.46 3.67l-1.3-1.3A1.95 1.95 0 0 0 15 20.23l1.3 1.3c-.79.38-1.65.58-2.53.57Z"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path d="M13.61 3.54V2" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
    <path d="m21.26 6.2 1.27-1.27" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M25.46 12.79H27" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M6.35 6.2 5.08 4.93" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M2.54 12.79H1" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
`;
export {
  icon_qCulturalInsights_default as default
};
//# sourceMappingURL=icon-qCulturalInsights.js.map
